import React from 'react'
import { withRouter } from 'react-router-dom'
import { useVersioning } from 'modules/versioning'
import { RouteProps } from 'constants/routes'
import {
  ArtboardDetailInfoFragment,
  UserFragment,
  VersionListItemFragment,
} from 'gqlTypes'
import VersionItem from 'components/VersionItem/VersionItem'

export type Artboard = Pick<
  ArtboardDetailInfoFragment,
  | 'identifier'
  | 'uuid'
  | 'shortId'
  | 'documentVersionShortId'
  | 'permanentArtboardShortId'
  | 'revisionIdentifier'
  | 'belongsToPrototype'
> | null

export interface ActivityRevisionProps extends RouteProps<'ARTBOARD_REVISION'> {
  createdAt: string
  createdAfterVersioning: boolean
  userIsCreator: boolean
  creator: Pick<UserFragment, 'identifier' | 'name'> | null
  artboard: Artboard
  isActive: boolean
  displayAsEnabled: boolean
  userCanAccessVersions: boolean
  kind: VersionListItemFragment['kind']
}

export const ActivityRevision = ({
  createdAt,
  userIsCreator,
  creator,
  match,
  artboard,
  createdAfterVersioning,
  userCanAccessVersions,
  isActive,
  kind,
}: ActivityRevisionProps) => {
  const { getPathname } = useVersioning()
  const { shareID, permanentArtboardShortId } = match.params

  const isDisabled = !userCanAccessVersions || !createdAfterVersioning

  // when `userCanAccessVersions===false` it is expected that the artboard will be undefined
  // as the user has no right to access it (and we are not querying for it)
  const { documentVersionShortId: revisionDocShortId } = artboard || {}

  const pathname =
    !isDisabled && revisionDocShortId
      ? getPathname({
          routeKey: 'ARTBOARD_REVISION',
          routeParams: {
            shareID,
            permanentArtboardShortId,
            revisionDocShortId,
          },
        })
      : undefined

  const tooltip =
    userCanAccessVersions && !createdAfterVersioning ? (
      <span>Updates created before July 23, 2019 are not available</span>
    ) : undefined

  return (
    <VersionItem
      type="revision"
      active={isActive}
      disabled={isDisabled}
      pathname={pathname}
      tooltip={tooltip}
      creator={creator?.name!}
      date={new Date(createdAt)}
      userIsCreator={userIsCreator}
      kind={kind || 'DRAFT'}
    />
  )
}

export default withRouter(ActivityRevision)
